// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "privacy_erasure_job".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "privacy_erasure_job" table (1:1 with a DB row, on the wire). */
export const privacyErasureJobAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    erasureId: z.string(),
    fingerprint: z.string(),
    task: z.unknown(),
    state: z.string(),
    createdAt: z.string().datetime(),
    enqueuedAt: z.string().datetime().nullable(),
    completedAt: z.string().datetime().nullable(),
    dlqRecordedAt: z.string().datetime().nullable(),
    failureCode: z.string().nullable(),
});
//# sourceMappingURL=privacyErasureJob.js.map